'use strict';

module.exports = {
  ADMIN: 'admin',
  AMBASSADOR: 'ambassador',
  APPLICANT: 'applicant',
  FOUNDER: 'founder',
  INVITED: 'invited',
  MEMBER: 'member',
  SUPER_ADMIN: 'superadmin',
  TEAM_LEADER: 'leader',
};
